module.exports = __webpack_public_path__ + "static/media/2.125a8c61.jpg";